// extracted by mini-css-extract-plugin
export default {"modal":"WarningModal_modal__gVf4L","title":"WarningModal_title__bSrFm","closeBtn":"WarningModal_closeBtn__yR1HW"};